module.exports = __webpack_public_path__ + "img/know-2.9e0c4132.jpg";